import { cn } from "@newxsystems/shared";
import { WohaAction } from "../WohaAction/WohaAction";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";
const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;
export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-4", centered && "items-center text-center")}>
      {eyebrow ? <p className="text-sm font-medium text-white/80">{eyebrow}</p> : null}
      {image ? (
        <WohaMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-2", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="font-satoshi text-4xl font-medium leading-[1.05] text-white text-balance md:text-5xl">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <WohaRichText
          className="max-w-[65ch] text-base leading-7 text-white/80"
          content={description}
        />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <WohaAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
CallToActionStacked.displayName = "Content::CallToActionStacked";
